import PropTypes from "prop-types";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../contexts/user.context";
import {
  // profilemenuItemList,
  accountMenuItemList,
} from "../../utils/defined-constants";
import ImageDropdown from "../dropdowns/image-dropdown/image-dropdown.component";
import AlignedImageBox from "../image-boxes/aligned-image-box/aligned-image-box";
import ProfileDropdownMenu from "../menus/profile-dropdown-menu/profile-dropdown-menu.component";
import Sidebar from "../sidebar/sidebar.component";

import notificationIcon from "../../assets/vectors/bell.svg";
import image from "../../assets/images/user.png";
import { ReactComponent as CheckedSVG } from "../../assets/vectors/Groupchecked.svg";
import MobileProfileMenu from "../menus/mobile-menu/mobile-profile-menu.component";
import { MdArrowBackIos } from "react-icons/md";

import { ReactComponent as EditUserSvg } from "../../assets/vectors/user-edit.svg";
import { ReactComponent as VerifySvg } from "../../assets/vectors/shield-tick.svg";
import { ReactComponent as SwitchRoleSvg } from "../../assets/vectors/Vector-1.svg";
import { ReactComponent as LogoutSvg } from "../../assets/vectors/logout.svg";
import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { auth, db, markNotificationAsRead } from "../../utils/firebase";
import Moment from "react-moment";

const DynamicMobileHeader = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const actionParam = searchParams.get("action");
  const { user } = useContext(UserContext);
  const [notifications, setNotifications] = useState(null);
  const myUserID = auth.currentUser?.uid;
  
  
  const isIndexHeader =
    (location.pathname === "/dashboard/property-list" ||
      location.pathname === "/dashboard/my-properties" ||
      location.pathname.includes("/dashboard/admin") ||
      location.pathname === "/dashboard/my-properties/") &&
    searchParams.get("action") !== "add-new";
  
  // isAccountHeader shows the account menu (blue header with profile info) - only when NO action param
  const isAccountHeader = location.pathname === "/dashboard/my-account" && !actionParam;
  
  // isInnerAccountHeader shows specific account sub-pages (edit profile, verify, password) - only when action param exists
  const isInnerAccountHeader = location.pathname === "/dashboard/my-account" && actionParam;
  
  const isbasicHeader =
    (location.pathname === "/dashboard/my-properties" &&
      searchParams.get("action") === "add-new") ||
    (!isInnerAccountHeader && !isIndexHeader && !isAccountHeader);

  // Determine back navigation path based on user role
  const getBackNavigationPath = () => {
    if (user?.viewing_as === "owner") {
      return "/dashboard/my-properties";
    } else if (user?.viewing_as === "tenant") {
      return "/dashboard/property-list";
    }
    return "/dashboard"; // fallback
  };

  const { logoutUser, mainMenuList, pageTitle, pendingAmount } = props;

  const profilemenuItemList = [
    {
      title: "Edit Profile",
      icon: <EditUserSvg className="inline-block mr-2 h-4" />,
      path: "/my-account",
    },
    {
      title: "Verify Account",
      icon: <VerifySvg className="inline-block -ml-1 mr-1 h-4" />,
      path: "/my-account?action=verify_account",
    },
    {
      title: "Switch Account",
      icon: <SwitchRoleSvg className="inline-block mr-2 pr-[1px] h-4" />,
      path: "/dashboard",
    },
    {
      title: "Logout",
      icon: <LogoutSvg className="inline-block mr-2 h-4" />,
      action: () => logoutUser("/login"),
    },
  ];

   const fetchNotification = async () => {
      if (myUserID != undefined || myUserID != null) {
        const notificationRef = collection(db, "notifications");
        const q = query(
          notificationRef,
          where("userId", "==", myUserID),
          orderBy("createdAt", "desc")
        );
  
        onSnapshot(q, (querySnapshot) => {
          let notifs = [];
          querySnapshot.forEach((doc) => {
            if (doc.data().unread === true) {
              notifs.push(doc.data());
            }
          });
          notifs = notifs.length > 10 ? notifs.slice(0, 10) : notifs;
          setNotifications(notifs);
        });
      }
    };

    useEffect(() => {
      if (notifications == null) {
          fetchNotification();
        }
    },[user])

  return (
    <>
      {isIndexHeader && (
        <div className="sticky top-0 z-[999] bg-white w-full px-4 flex justify-between items-center pt-4 pb-1 lg:hidden">
          <div className="flex gap-2 items-center">
            <ImageDropdown
              panelElement={
                <>
                  <AlignedImageBox
                    profileImage={user.profile_photo}
                    text={user.first_name + " " + user.last_name}
                    subtext={"@" + user.nickname}
                  />
                  <ProfileDropdownMenu menuItemList={profilemenuItemList} />
                </>
              }
              check={user.verify_user === 0 || !user.verify_user ? false : true}
              image={{ src: user.profile_photo ? user.profile_photo : "" }}
              className="rounded-full w-[40px] h-[40px]"
              appendClass={"-translate-x-[8%] -mt-[2px]"}
            />
            <span className="h-[5px] w-[5px] bg-red-600 inline-block rounded-full absolute left-14 -mt-9 -ml-2"></span>
            <span className="text-light header-font -mt-2 text-sm">
              Hi {user.first_name},
            </span>
          </div>
          {pendingAmount > 0 && ( 
            
            <div 
            className="border border-primary rounded-lg h-8 flex justify-center items-center min-w-12 p-4 shadow-md select-none bg-white"
            >
                <span className="">
                  {" "}
                  ₦: {pendingAmount.toLocaleString() || "0.00"}{" "}
                </span>
              </div>
              )}
          <div className="flex gap-5 items-center">
             <ImageDropdown
                          notifyCount={
                            notifications != null
                              ? notifications.filter((e) => e.unread === true).length
                              : 0
                          }
                          panelElement={    
                            <div className="w-full flex h-[60%] md:h-[80%] overflow-auto gap-2 flex-col divide-y divide-gray-400 divide-opacity-30">
                              {notifications != null && notifications.length > 0 ? (
                                <>
                                  {notifications.map((not, index) => (
                                    <div key={index} className="flex flex-col py-1">
                                      <p className="text-sm">
                                        {not.message}
                                        <span className="ml-2 text-xs capitalize">
                                          <Moment fromNow>{not.createdAt.toDate()}</Moment>
                                        </span>
                                      </p>
                                    </div>
                                  ))}
                                  <button
                                    onClick={() =>
                                      markNotificationAsRead(auth.currentUser.uid)
                                    }
                                  >
                                    Mark all as read
                                  </button>
                                </>
                              ) : (
                                <div>
                                  <h4 className="text-center text-sm">
                                    No notifications found
                                  </h4>
                                </div>
                              )}
                            </div>
                          }
                          image={{ src: notificationIcon, size: "24" }}
                          nocaretIcon={true} 
                          appendClass={"right-0 translate-x-[68px]  w-[350px]"}

                        />
            <Sidebar menuItemList={mainMenuList} />
          </div>
        </div>
      )}

      {isAccountHeader && (
        <div className="lg:hidden">
          <div className="sticky top-0 z-[999] bg-primary text-white w-full px-4 pt-8  flex flex-col justify-center items-center header-font">
            <div className="justify-center items-center pt-4 pb-3 text-sm">
              <Sidebar menuItemList={mainMenuList} backButton={getBackNavigationPath()} />
              Account
            </div>

            <div className="mt-10 mb-5 flex flex-col justify-center items-center">
              <img
                id="profile-image-preview"
                className="p-1 shadow-md border-white border-2 cursor-pointer h-[100px] w-[100px] rounded-full object-cover"
                src={user?.profile_photo ? user.profile_photo : image}
                alt="profile-img"
              />

              <div className="flex justify-center mt-5 gap-2">
                {user.first_name + " " + user.last_name}
                {user.verify_user === 1 && <CheckedSVG className="w-5 h-5" />}
              </div>
            </div>
          </div>

          <MobileProfileMenu menuItemList={accountMenuItemList} />
        </div>
      )}

      {isInnerAccountHeader && (
        <div className="sticky top-0 z-[999] bg-white w-full px-4 flex justify-center items-center pt-4 pb-3 lg:hidden header-font text-lg shadow-sm">
          <button
            className="absolute left-4 z-50 w-auto h-auto p-2 inline-flex items-center justify-center cursor-pointer hover:bg-gray-100 rounded"
            onClick={() => {
              // Navigate back to main account page, clearing the action param
              navigate("/dashboard/my-account", { replace: false });
              window.scrollTo(0, 0);
            }}
            aria-label="Go back to account"
          >
            <MdArrowBackIos className="w-5 h-5" />
          </button>
          <span className="flex-1 text-center">{pageTitle}</span>
        </div>
      )}

      {isbasicHeader && (
        <div className="sticky top-0 z-[999] bg-white w-full px-4 flex justify-center items-center pt-4 pb-3 lg:hidden header-font text-lg">
          <Sidebar menuItemList={mainMenuList} backButton={true} />
          {pageTitle} 
        </div>
      )}
    </>
  );
};

DynamicMobileHeader.propTypes = {
  user: PropTypes.shape({
    profile_photo: PropTypes.string,
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    nickname: PropTypes.string,
    verify_user: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  }).isRequired,
  logoutUser: PropTypes.func.isRequired,
  mainMenuList: PropTypes.array.isRequired,
  pageTitle: PropTypes.string.isRequired,
};

export default DynamicMobileHeader;
